import { useContext, useState } from "react";

import { PostBillContext } from "@app/provider";
import { HEAP_EVENTS } from "@app/provider/types";
import { PostBillNotificationTemplate } from "@app/hooks/useGeneratedTokenizedLink";

export interface HeapExtraData {
  pay_plan_length?: number;
  payment_method?: string | null;
  workflow?: string;
  failure_reason?: string;
  wallet_type?: string;
  tests_ordered?: string;
  lims_clinic_id?: string;
  public_login_method?: string;
  date_of_birth?: string;
  first_name?: string;
  last_name?: string;
  case_number?: string;
  zip_code?: string;
  mobile_number?: string;
  email?: string;
}
interface TrackPostBillHeapEventProps {
  eventKey: HEAP_EVENTS;
  extraData?: HeapExtraData;
}

const usePostBillHeapEvent = (): {
  trackPostBillHeapEvent: ({
    eventKey,
    extraData,
  }: TrackPostBillHeapEventProps) => void;
} => {
  const [isFirstCall, setIsFirstCall] = useState(true);
  const { patientUid } = useContext(PostBillContext);

  if (isFirstCall && patientUid) {
    heap.identify(patientUid!);
    setIsFirstCall(false);
  }

  const trackPostBillHeapEvent = ({
    eventKey,
    extraData,
  }: TrackPostBillHeapEventProps) => {
    const heapEventData = {
      notification_type: PostBillNotificationTemplate.POST_BILL_COMM,
      ...extraData,
    };
    heap.track(eventKey, heapEventData);
  };

  return { trackPostBillHeapEvent };
};

export default usePostBillHeapEvent;
